export const contentTableConfig = {
  title: '运营商列表',
  propList: [
    { prop: 'deptName', label: '运营商名称', minWidth: '120' },
    { prop: 'leader', label: '负责人名称', minWidth: '100' },
    { prop: 'phone', label: '电话号码', minWidth: '120' },
    { prop: 'email', label: '邮箱', minWidth: '150' },
    { prop: 'locationProvince', label: '省份', minWidth: '100' },
    { prop: 'locationCity', label: '城市', minWidth: '100' },
    { prop: 'locationCounty', label: '县/区', minWidth: '100' },
    { prop: 'locationFullName', label: '所在地', minWidth: '150' },
    { prop: 'inviteCode', label: '运营商邀请码', minWidth: '120' },
    { prop: 'orderNum', label: '排序', minWidth: '100' },
    { prop: 'status', label: '运营商状态', minWidth: '100',slotName: 'statusSlot' },
    { prop: 'delFlag', label: '删除状态', minWidth: '100',slotName: 'delFlag' },
    { prop: 'handler', label: '操作', minWidth: '250',slotName: 'operate' },
  ],
  showIndexColumn: false,
  showSelectColumn: false,
  showFooter: false
} 